import React from 'react'

import { Icons } from 'src/ui/icons'

export const CULTURE_DATA = [
  {
    id: 'news',
    icon: <Icons.NewsIcon />,
    title: 'Корпоративный журнал',
    body:
      'Рассказываем о проектах, командах и людях — делимся новостями, достижениями и вдохновляющими историями изнутри',
  },
  {
    id: 'food',
    icon: <Icons.FoodIcon />,
    title: 'Странные пятницы',
    body:
      'Играем в квиз и пробуем кухни разных стран, делимся впечатлениями, объединяем команды из разных городов',
  },
  {
    id: 'heart',
    icon: <Icons.HeartIcon />,
    title: 'Пульс-опросы',
    body:
      'Открыто спрашиваем, как чувствует себя команда. Иногда — с юмором: выбираем, на кого из персонажей похожи кодеры',
  },
  {
    id: 'team',
    icon: <Icons.TeamIcon />,
    title: 'Клубы по интересам',
    body:
      'Книги, спорт, игры, питомцы — объединяемся вне рабочих задач, чтобы делиться увлечениями и находить единомышленников',
  },
  {
    id: 'hello',
    icon: <Icons.HelloIcon />,
    title: 'Welcome-анкеты',
    body:
      'Каждому новому коллеге — тёплый старт, знакомство с командой и возможность сразу проявить себя',
  },
  {
    id: 'sun',
    icon: <Icons.SunIcon />,
    title: 'Тёплый понедельник',
    body:
      'Eженедельный день благодарности: делимся добрыми словами и поддержкой — без повода, просто так',
  },
  {
    id: 'footprints',
    icon: <Icons.FootPrintsIcon />,
    title: 'Прогулки с удалёнными сотрудниками',
    body:
      'Если не в одном офисе — гуляем по разным городам вместе. Дистанция — не повод терять связь',
  },
]
